export default __webpack_public_path__ + "static/media/icon-24.54c3277b.png";